import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useUpdateProjectChecklistTemplateNotifications = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['updateProjectChecklistTemplateVersionNotifications']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.updateProjectChecklistTemplateVersionNotifications,
    ...options,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: checklistTemplateKeys.getProjectVersion({
          projectId: variables.projectId,
          templateId: variables.templateId,
        }).queryKey,
      })
    },
  })
}
